<template>
  <div class="home">
    <header-bar />
    <div id="events">
      <h2>Upcoming events</h2>
      <home-event
        v-for="event in events"
        v-bind:key="event.id"
        :title="event.title"
        :startDate="event.startTime"
        :endDate="event.endTime"
        :description="event.description"
        :location="event.location"
        :id="event.id"
      />
      <small v-if="events.length === 0"><i>No upcoming events.</i></small>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import HeaderBar from "@/components/HeaderBar.vue";
import API_URL from "@/api_url";
import axios from "axios";
import HomeEvent from "@/components/HomeEvent.vue";

export default defineComponent({
  name: "HomeView",
  components: {
    HeaderBar,
    HomeEvent,
  },
  data() {
    const events = [] as {
      id: string;
      title: string;
      startTime: Date;
      endTime: Date;
      location: string;
      description: string;
    }[];

    return {
      events,
    };
  },
  created() {
    (async () => {
      let data;
      try {
        data = await axios.get(`${API_URL}/data/me/events/assigned`, {
          withCredentials: true,
        });
      } catch (e) {
        console.log("Couldný get events.");
        return;
      }

      const now = new Date();

      if (!data.data.data) {
        return;
      }

      data.data.data.forEach(
        (event: {
          EndTime: string;
          description: string;
          id: string;
          location: string;
          startTime: string;
          title: string;
        }) => {
          if (now > new Date(event.EndTime)) return;
          this.events.push({
            id: event.id,
            title: event.title,
            startTime: new Date(event.startTime),
            endTime: new Date(event.EndTime),
            location: event.location,
            description: event.description,
          });
        }
      );
    })();
  },
});
</script>

<style>
#events {
  padding: 20px;
  padding-top: 0;
}
</style>
